import axios from "axios";

import InfoPicherService from "../../../components/application/statement_hostel/Services/Api/InfoPicher";

const MainHostelStore = {
    namespaced: true,
    state: {
        user: {},
        record_book: '',
        statement_hostels: [],
        ifRatingloading: false,
        privilege: {},
        fluorography: '',
        ifFluraloading: true,
        check_index: true,
        academic_rating: '',
        last_semesters: []

    },
    getters: {
        setPrivilege(state){
            if(state.privilege?.name){
                return state.privilege.name
            }
            else return 'Отсутствует'
        },
        semestrsInfo(state){
            let semesters = []

            state.record_book.records.forEach((element) => {
                if ((element.type_of_the_control === 'Экзамен' ||
                    element.type_of_the_control === 'Зачет с оценкой' ||
                    element.type_of_the_control === 'Курсовая работа') && (element.term === state.record_book.last_semesters[0] || element.term === state.record_book.last_semesters[1])){
                    semesters.push(element)
                }
            })
            return semesters
        },
    },
    mutations: {
        setUser(state, response) {
            state.user = response.person;
        },
        setRecordBook(state, response){
            state.record_book = response;
        },
        setLastSemesters(state, response){
            state.last_semesters = response;
        },
        setRatingAcademic(state, response){
            state.academic_rating = response;
        },
        setStatement(state, response) {
            state.statement_hostels = response;
        },
        setBadName(state, bad_name){
            state.bad_name = bad_name;
        },
        setPrivilege(state, response){
            state.privilege = response;
        },
        setFluorography(state, fluorography){
            state.fluorography = fluorography;
        },
        setRatingLoad(state, bool){
            state.ifRatingloading = bool;
        },
        setFluraLoad(state, bool){
            state.ifFluraloading = bool;
        },
        checkIndex(state, bool){
            state.check_index = bool;
        },

    },
   actions: {
       async GetUser({commit}) {
           const response = await InfoPicherService.show();

           commit('setUser', response.data)
       },
       async GetRecordBook({commit}){
           commit('setRatingLoad', true)

           const response = await InfoPicherService.get_record_book();

           commit('setRecordBook', response.data)
           commit('setRatingLoad', false)
       },
       async GetPrivilege({state, commit}){
           const response = await InfoPicherService.get_privilege();

           commit('setPrivilege', response.data)
       },
       async Fluorography({commit}){
           const response = await InfoPicherService.fluorography()

           commit('setFluorography', response.data)
       },
    }

}

export default MainHostelStore